import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';

import {
  setModal
} from "../../../../actions/index";
import {
  setStateLockPM,
  setEnablePM
} from "../redux/actions/index";

import NoSubscription from '../modals/NoSubscription';
import ModalCTA from '../../modal/ModalCTA';
import ModalButton from '../../modal/ModalButton';

// USE AFTER SIGN IN
const useInvitPM = () => {
  const dispatch = useDispatch();
  const enable = useSelector( state => state.enablePM );
  const user = useSelector( state => state.user);
  const isSubscribed = useSelector( state => state.isSubscribed );
  const api = useSelector( state => state.api );

  // Invitation to Party Mode From a User Host
  useEffect(() => {
    const roomInvitation = JSON.parse(localStorage.getItem('invit_pm'));
    if (!enable && roomInvitation) {

      setTimeout(() => {
        if (roomInvitation.active && !isSubscribed && user) {
          api.getFromApi(`/my/subscriptions/`, false).then( res => {
            const expired = (res.data && res.data.status) ? res.data.status.includes('expired') : false;
            dispatch(setModal({
              content: <NoSubscription trial={!expired} />
            }));
          })
          localStorage.removeItem('invit_pm');
        } else { // ACTIVE OR VIEWER
          const { id, owner, active, token } = roomInvitation;
          const validClick = () => {
            localStorage.setItem('a5RAW%93W!gph8', id); // Auto-Connect to the room
            localStorage.setItem('5gxYD7Y&PqWmDW', active); // Invitation Type: Active (true) / Viewer (false)
            localStorage.setItem('UFg%PZHqK&5j4C', token); // Token
            dispatch(setStateLockPM(false));
            dispatch(setEnablePM(true));

            if (window.compact_toggle && window.compact_mode_enable) { window.compact_toggle(); }
          }
          if (active && user && isSubscribed) {
            dispatch(setModal({
              content: (
                <ModalCTA
                  title={`Welcome to the party`}
                  description={`'${owner}' invited you.`}
                  styleContainer={{marginTop: `-70%`, marginLeft: `-5%`}}
                  styleBody={{ gap: 16 }}
                  styleDescription={{ marginBottom: 16 }}
                >
                  <ModalButton label={`Start DJing`} onClick={validClick} />
                </ModalCTA>
              )
            }));
            localStorage.removeItem('invit_pm');
          } else if (!active) {
            dispatch(setModal({
              content: (
                <ModalCTA
                  title={`Welcome to the party`}
                  description={`'${owner}' invited you.`}
                  styleContainer={{marginTop: `-60%`, marginLeft: `-5%`}}
                  styleBody={{ gap: 16 }}
                  styleDescription={{ marginBottom: 16 }}
                >
                  <ModalButton label={`Start watching`} onClick={validClick} />
                </ModalCTA>
              )
            }));
            localStorage.removeItem('invit_pm');
          }
        }
      }, 1000);
    }
  }, [enable, user, isSubscribed, api, dispatch])

  // Popup Reconnect after disconnect without leaving the room
  const connected = useSelector( state => state.socketConnectPM );
  const socket = useSelector( state => state.socketPM);
  const lockPM = useSelector( state => state.lockPM);
  useEffect(() => {
    const roomID = localStorage.getItem('a5RAW%93W!gph8');
    if (enable && user && roomID && connected && socket && (lockPM || ( typeof lockPM === 'undefined')) ) {
      setTimeout(() => {
        const validClick = () => {
          dispatch(setStateLockPM(false));
          if (window.compact_toggle && window.compact_mode_enable) { window.compact_toggle(); }
        }
        const cancelClick = () => {
          localStorage.removeItem('a5RAW%93W!gph8');
          socket.emit("close or leave room", { roomID: roomID });
          dispatch(setEnablePM(false));
        }
        dispatch(setModal({
          content: (
            <ModalCTA
              title={`Looks like you stepped out?`}
              styleContainer={{marginTop: `-70%`, marginLeft: `-10%`}}
              classModal={`bottom-reduce`}
              styleBody={{ gap: 36 }}
            >
              <ModalButton label={`Re-enter set`} onClick={validClick} />
              <ModalButton label={`No thanks`} className={`cancel`} onClick={cancelClick} />
            </ModalCTA>
          ),
          underlayClickExits: false
        }));

      }, 500);
    }
  }, [enable, user, socket, connected, lockPM, dispatch])

  return null;
};

export default useInvitPM;
